export const extractCustomerDashboardMeta = ({ customer_dashboard_meta }) => {
  const has_seen_product_tour = customer_dashboard_meta.some(
    ({ event, status }) => event === 'PRODUCT_TOUR' && status === 'FINISHED'
  )

  const has_seen_favored_space_hint = customer_dashboard_meta.some(
    ({ event, status }) => event === 'FAVORED_SPACE_HINT' && status === 'SEEN'
  )

  const has_seen_store_partner_logo_hint = customer_dashboard_meta.some(
    ({ event, status }) => event === 'STORE_PARTNER_LOGO' && status === 'SEEN'
  )

  const ui_settings_general = customer_dashboard_meta.find(
    ({ id }) => id === 'UI_GENERAL'
  ) || { id: 'UI_GENERAL' }

  const ui_space_state_hint = customer_dashboard_meta.find(
    ({ id }) => id === 'UI_SPACE_STATE_HINT'
  ) || { id: 'UI_SPACE_STATE_HINT' }

  const hasSeenOrSubmittedMatchingProfileFeedback =
    customer_dashboard_meta.some(
      ({ event, status }) =>
        event === 'FEEDBACK_MATCHINGPROFILE' &&
        (status === 'SEEN' || status === 'SUBMITTED')
    )

  const hasSeenOrSubmittedTalentProfileFeedback = customer_dashboard_meta.some(
    ({ event, status }) =>
      event === 'FEEDBACK_TALENTPROFILE' &&
      (status === 'SEEN' || status === 'SUBMITTED')
  )

  const hasSeenOrSubmittedRequirementProfileFeedback =
    customer_dashboard_meta.some(
      ({ event, status }) =>
        event === 'FEEDBACK_REQUIREMENTPROFILE' &&
        (status === 'SEEN' || status === 'SUBMITTED')
    )

  const hasSeenHelpSupportHint = customer_dashboard_meta.some(
    ({ event, status }) =>
      event === 'SHOW_HELP_SUPPORT_HINT' && status === 'SEEN'
  )

  return {
    has_seen_product_tour,
    has_seen_favored_space_hint,
    has_seen_store_partner_logo_hint,
    hasSeenOrSubmittedMatchingProfileFeedback,
    hasSeenOrSubmittedTalentProfileFeedback,
    hasSeenOrSubmittedRequirementProfileFeedback,
    hasSeenHelpSupportHint,
    ui_settings_general,
    ui_space_state_hint
  }
}
